import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { pillars, volumes, volumeIncludes } from '../data/volumes';
export function Volumes() {
  return <section aria-label="Contenu du système" className="bg-transparent" data-id="element-272" data-mp="184f1q1waxg7h">
      <div className="mx-auto max-w-6xl px-5 py-12" style={{
      paddingTop: '19px',
      paddingBottom: "21px"
    }} data-id="element-273" data-mp="1822aey4nlthr">
        <div className="text-center" data-id="element-274" data-mp="1zv1lv75xmzld">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-blush" data-id="element-275" data-mp="1zw4epkmtfc3x">
            LES 100 PRÉCÉDENTS JURIDIQUES AI™ : LE SYSTÈME
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-276" data-mp="1qud90fs9z5a2">
            📚 Le Coffre-Fort Stratégique en 6 Volumes
          </h2>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-277" data-mp="1vrwlba5ex7zd">
            {pillars.map(p => <span key={p} className="rounded-full border border-grape/25 bg-lilac-soft px-3 py-1 text-xs font-bold uppercase tracking-wide text-grape-deep" data-id="element-278" data-mp="fe6j68xustsd">
                {p}
              </span>)}
          </div>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-279" data-mp="3o8ey40otari7">
          {volumes.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 3 * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="rounded-2xl border border-grape/15 bg-white p-5" style={{
          paddingTop: "10px",
          paddingBottom: "8px"
        }} data-id="element-280" data-mp="3jawoe82z0895" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-281" data-mp="krgbbitzkp01">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-plum font-display text-lg font-black text-white" data-id="element-282" data-mp="kqwuk5g2o6nl">
                  {String(t.n).padStart(2, '0')}
                </span>
                <h3 className="text-sm font-bold leading-tight text-plum" data-id="element-283" data-mp="tq1t3brmvzzr">
                  <span aria-hidden="true" data-id="element-284" data-mp="ps42c4i7t5u9">{t.emoji} </span>
                  {t.title}
                </h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-plum/65" data-id="element-285" data-mp="wrmt5znhp9qj">{t.desc}</p>
            </motion.article>)}
        </div>

        <div className="mt-10 rounded-2xl border border-grape/25 bg-white p-6" data-id="element-286" data-mp="16s6u1173kc88">
          <p className="text-center font-display text-lg font-black text-grape" data-id="element-287" data-mp="16q2grsnb60va">
            ✅ Chaque volume inclut :
          </p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-288" data-mp="1fl0dzbxhnzsf">
            {volumeIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-plum/75" data-id="element-289" data-mp="1kj1ze3ie0b72">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-290" data-mp="1pies34vxwchk" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}